// extracted by mini-css-extract-plugin
var _1 = "AiAskWidget-module__button--HezHo";
var _2 = "AiAskWidget-module__content--HaAx0";
var _3 = "AiAskWidget-module__header--kFBnN";
var _4 = "AiAskWidget-module__title--j6VQK";
var _5 = "AiAskWidget-module__widget--ZCOa9";
export { _1 as "button", _2 as "content", _3 as "header", _4 as "title", _5 as "widget" }
